import initLabels from '~/init_labels';

document.addEventListener('DOMContentLoaded', initLabels);



// WEBPACK FOOTER //
// ./pages/groups/labels/index/index.js